import { defaultTheme, ToggleTheme } from '@medly-components/theme';

import colors from './colors';

export const toggle: ToggleTheme = {
    ...defaultTheme.toggle,
    defaultSize: 'M',
    outlineColor: colors.darkBlue,
    iconColor: colors.white,
    bgColor: {
        default: colors.grey[200],
        checked: colors.coral[500],
        disabledDefault: colors.grey[400],
        disabledChecked: colors.coral[200]
    },
    textColor: {
        default: colors.professionalNavy,
        disabled: colors.grey[400]
    }
};
